var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmbotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.83 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fmbt-icon-cls-1{fill:#307fbe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fmbt-icon-cls-1",
    d: "M19.62,15.52A25.58,25.58,0,0,0,16.24,8.4a.59.59,0,0,0-1,0h0a37.5,37.5,0,0,0-2.58,4.79,9.74,9.74,0,0,0-1,3.87,10.14,10.14,0,0,0,3.15,7.24,8.69,8.69,0,0,1-2,1C9.11,24,6.13,19.88,7.11,15.86s3.74-7.79,6.16-11.13l0-.06a.48.48,0,0,0,.11-.3v0a.68.68,0,0,0-.11-.23l0-.06h0c-1-1.31-1.94-2.61-3-3.86a.55.55,0,0,0-.8,0A68.1,68.1,0,0,0,2.37,10.4c-1.58,2.84-3,5.86-2.09,9.16A10,10,0,0,0,8.84,27a10,10,0,0,0,10-5.59A9,9,0,0,0,19.62,15.52ZM5.75,24.83c-3.43-1.9-5.51-6-4.24-9.85A36.4,36.4,0,0,1,6.6,5.87c1.06-1.5,2.15-3,3.3-4.4.76,1,1.5,1.93,2.22,2.91a59.62,59.62,0,0,0-4,6.26,16.06,16.06,0,0,0-2.23,5.88A9.8,9.8,0,0,0,11,25.79,8.32,8.32,0,0,1,5.75,24.83ZM17.4,21.66a8.76,8.76,0,0,1-1.67,2,8.66,8.66,0,0,1-2.92-6.76c.17-2.5,1.6-4.95,2.93-7.09a20.5,20.5,0,0,1,2.79,6.05A8,8,0,0,1,17.4,21.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-icon-cls-1",
    d: "M13.42,4.37a.46.46,0,0,1-.15.36l0-.06A.48.48,0,0,0,13.42,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fmbt-icon-cls-1",
    d: "M13.42,4.32a.68.68,0,0,0-.11-.23l0-.06A.48.48,0,0,1,13.42,4.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmbotIcon);
export default __webpack_public_path__ + "static/media/farmbot-icon.53f5d9640c41430404c1e53aa6f63622.svg";
export { ForwardRef as ReactComponent };